import React from 'react';
import cn from 'classnames';

import { MomentsProvider, useMoments } from './MomentsContext';
import MomentsGallery from './MomentsGallery';
import MomentsBuilder from './MomentsBuilder';
import MomentShopPane from './MomentShopPane';

import './Moments.scss';

/*
  Moments editor bench. State (routing, polling, run state, editor actions)
  lives in MomentsProvider; this shell just picks the view: the gallery
  landing, or the builder (conversation rail + live moment preview).
*/
const MomentsShell = () => {
  const { view, showMoment } = useMoments();

  if (view === 'gallery') return <MomentsGallery />;

  return (
    <div className={cn('msa-outer', { 'msa-split': showMoment })}>
      <MomentsBuilder />
      {showMoment && <MomentShopPane />}
    </div>
  );
};

const Moments = () => (
  <MomentsProvider>
    <MomentsShell />
  </MomentsProvider>
);

export default Moments;
